<template>
  <v-dialog v-model="dialog" max-width="600px" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÔNG TIN LỊCH HẸN</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <v-row class="pb-6">
          <v-col cols="6">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{on, attrs}">
                <v-text-field
                  v-model="date"
                  label="Ngày"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable @input="menu = false" />
            </v-menu>
          </v-col>
          <v-col cols="3">
            <v-select v-model="hour" :items="hours" label="Giờ" outlined hide-details></v-select>
          </v-col>
          <v-col cols="3">
            <v-select v-model="minute" :items="minutes" label="Phút" outlined hide-details></v-select>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-textarea
              v-model="note"
              label="Ghi chú (nếu có)"
              placeholder="Ghi chú (nếu có)"
              outlined
              hide-details
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
        <v-spacer></v-spacer>

        <v-btn color="blue darken-4" dark @click="confirm">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean
  },
  data() {
    return {
      date: '',
      time: '',
      note: '',
      menu: false,
      menu2: false,
      hour: null,
      minute: null,
      hours: Array.from({length: 24}, (_, i) => i),
      minutes: Array.from({length: 60}, (_, i) => i)
    }
  },
  computed: {},
  methods: {
    confirm() {
      if (this.date && (this.hour !== null || this.minute !== null)) {
        let formattedMinute = this.minute !== null && this.minute !== '' ? this.minute : 0
        let formattedTime = `${this.hour.toString().padStart(2, '0')}:${formattedMinute.toString().padStart(2, '0')}`
        const dateTime = new Date(this.date + 'T' + formattedTime)
        const formattedDateTime = dateTime.toISOString()
        this.$emit('inputConfirmed', {date: formattedDateTime, note: this.note})
      } else {
        this.$emit('inputConfirmed', {date: '', note: this.note})
      }
      this.$emit('closeAppointment', false)
    },

    cancel() {
      this.$emit('closeAppointment', false)
    }
  }
}
</script>
